import { render, staticRenderFns } from "./OrderDetailContent.module.vue?vue&type=template&id=d287d326&scoped=true&"
import script from "./OrderDetailContent.module.vue?vue&type=script&lang=js&"
export * from "./OrderDetailContent.module.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailContent.module.vue?vue&type=style&index=0&id=d287d326&lang=scss&scoped=true&"
import style1 from "./OrderDetailContent.module.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d287d326",
  null
  
)

export default component.exports